import { attachDialogFooterListeners, getDeleteDialogButtons } from '../shared/dialogUtils';
import { GzDialog } from '../../../ui/gzDialog/component/GzDialog';
import { GzDialogWebComponent } from '../../../ui/gzDialog';

export class DeleteDialog {
  static open(translateFn: Function): GzDialogWebComponent {
    const dialogBody = document.createElement('div');
    dialogBody.innerHTML = `<p>${translateFn('Are you sure you want to delete the selected items?')}</p>`;

    const footerContent = getDeleteDialogButtons(translateFn);
    const dialogConfigs: GzDialog = {
      headline: translateFn('Delete'),
      bodyContent: dialogBody,
      isOpen: true,
      footerContent,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs);

    attachDialogFooterListeners(footerContent, dialog);

    return dialog;
  }
}
